import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  index?: number;
}

export default function MediaCard({ item, index = 0 }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 高清影视封面`}
          title={`${item.title} 剧情介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-xs font-label">
          {item.type}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-bold font-label flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 font-label">
          {item.year} · {item.region} · {item.duration}
        </p>
        <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2 h-9">{item.synopsis}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.genres.slice(0, 3).map((g) => (
            <span key={g} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}